import { render, staticRenderFns } from "./ContainerBoxesCard.vue?vue&type=template&id=87d22236"
import script from "./ContainerBoxesCard.vue?vue&type=script&lang=js"
export * from "./ContainerBoxesCard.vue?vue&type=script&lang=js"
import style0 from "./ContainerBoxesCard.vue?vue&type=style&index=0&id=87d22236&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports